import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import { useGetRecheckCertificateListsQuery } from "../../../../store/queries/Printing";
import useGLIPrintRecheck from "./useGLIPrintRecheck";
import Style from "./gliprint.module.scss";

const statusOptions = [
  { name: "COMPLETED", id: 2 },
  { name: "MARKED", id: 5 },
];

const certificateTypes = [
  { _id: 1, name: "Card Certificate" },
  { _id: 2, name: "Big Card Certificate" },
  { _id: 3, name: "Paper Certificate" },
  { _id: 4, name: "Foldable Card" },
];

const GLIPrintRecheck = () => {
  const {
    formik,
    handleCloseModal,
    getFieldError,
    setCardSize,
    isLoading,
    gliItems,
    uniqueItemTypes,
    handleItemChange,
    gliEntries,
    setGliEntries,
    loadGliOptions,
    selectedValId,
  } = useGLIPrintRecheck();

  const [selectedId, setSelectedId] = useState([]);
  const { data: basicData } = useGetRecheckCertificateListsQuery(
    {
      id: selectedId,
      is_bulk: true,
    },
    {
      skip: !formik?.values?.gli_data[0]?.gli_number || selectedId.length === 0,
    }
  );

  const reportListData = basicData?.data?.report_list?.filter(
    (item) => item?.certificate_type === formik?.values?.certificate_type?._id
  );

  useEffect(() => {
    const formattedGliData = gliEntries.map((entry) => ({
      gli_number: entry.gli_number?.gli_number || "",
      status: Array.isArray(entry.status) ? entry.status : null,
      report_id: entry.report_id?._id || "",
      _id: entry.gli_number?._id || "",
    }));

    const lastId = gliEntries[gliEntries.length - 1]?.gli_number?._id;
    if (lastId) {
      setSelectedId([lastId]);
    }

    formik.setFieldValue("gli_data", formattedGliData);
    formik.setFieldTouched("gli_data", true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gliEntries]);

  const handleAddGLI = () => {
    const newId = gliEntries.length + 1;
    setGliEntries([
      ...gliEntries,
      { id: newId, gli_number: null, status: [], report_id: null, _id: null },
    ]);
  };

  const handleRemoveGLI = (id) => {
    if (gliEntries.length > 1) {
      setGliEntries(gliEntries.filter((entry) => entry.id !== id));
    }
  };

  const handleFieldChange = (fieldName, value, entryId, index) => {
    const updatedEntries = gliEntries.map((entry) =>
      entry.id === entryId ? { ...entry, [fieldName]: value } : entry
    );
    setGliEntries(updatedEntries);
    formik.setFieldValue(`gli_data[${index}].${fieldName}`, value);
  };

  const getGliFieldError = (fieldName, index) => {
    if (
      formik?.errors?.gli_data &&
      formik?.touched?.gli_data &&
      Array.isArray(formik.errors.gli_data) &&
      formik.errors.gli_data[index] &&
      formik.touched.gli_data[index]
    ) {
      return formik.errors.gli_data[index][fieldName];
    }
    return null;
  };

  const getGliArrayError = () => {
    if (
      formik?.errors?.gli_data &&
      formik?.touched?.gli_data &&
      typeof formik.errors.gli_data === "string"
    ) {
      return formik.errors.gli_data;
    }
    return null;
  };

  return (
    <div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Item Type
        </label>
        <Select
          id="item_type"
          placeholder={"Select"}
          className={`pro-input lg  ${getFieldError("item_type") && " error"}`}
          classNamePrefix="pro-input"
          isMulti={false}
          name="item_type"
          options={uniqueItemTypes}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.name}
          value={formik?.values?.item_type}
          onChange={handleItemChange}
          menuPlacement="auto"
          onBlur={formik?.handleBlur("item_type")}
        />
        {getFieldError("item_type") && (
          <span className="error-text">{getFieldError("item_type")}</span>
        )}
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Certificate Type
        </label>
        <Select
          id="certificate_type"
          name="certificate_type"
          placeholder={"Select"}
          className={`pro-input lg  ${
            getFieldError("certificate_type") && " error"
          }`}
          classNamePrefix="pro-input"
          options={certificateTypes}
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?._id}
          value={formik?.values?.certificate_type}
          onBlur={formik.handleBlur("certificate_type")}
          onChange={(value) => {
            formik?.setFieldValue("certificate_type", value || null);
          }}
          menuPlacement="auto"
        />
        {getFieldError("certificate_type") && (
          <span className="error-text">
            {getFieldError("certificate_type")}
          </span>
        )}
      </div>

      {(formik?.values?.certificate_type?._id === 1 ||
        formik?.values?.certificate_type?._id === 3) && (
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Side
          </label>
          <Select
            id="side"
            name="side"
            placeholder={"Select"}
            className={`pro-input lg  ${getFieldError("side") && " error"}`}
            classNamePrefix="pro-input"
            options={[
              { name: "Front", id: 1 },
              { name: "Back", id: 2 },
              { name: "Duplex", id: 3 },
            ]}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            value={formik?.values?.side}
            onBlur={formik.handleBlur("side")}
            onChange={(value) => {
              formik?.setFieldValue("side", value || null);
            }}
            menuPlacement="auto"
          />
          {getFieldError("side") && (
            <span className="error-text">{getFieldError("side")}</span>
          )}
        </div>
      )}

      {formik?.values?.certificate_type?._id === 1 && (
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Card Size
          </label>
          <Select
            id="card_size"
            name="card_size"
            placeholder={"Select"}
            className={`pro-input lg ${getFieldError("card_size") && " error"}`}
            classNamePrefix="pro-input"
            options={[
              { name: "Normal (7.8)", id: 1 },
              { name: "Large (8.5)", id: 2 },
            ]}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            value={formik?.values?.card_size}
            onBlur={formik.handleBlur("card_size")}
            onChange={(value) => {
              setCardSize(value);
            }}
            menuPlacement="auto"
          />
          {getFieldError("card_size") && (
            <span className="error-text">{getFieldError("card_size")}</span>
          )}
        </div>
      )}

      {((formik?.values?.certificate_type?._id === 1 &&
        formik?.values?.side?.id === 1) ||
        formik?.values?.certificate_type?._id === 2) && (
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Certificate Format
          </label>
          <Select
            id="certificate_format"
            name="certificate_format"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("certificate_format") && " error"
            }`}
            classNamePrefix="pro-input"
            options={[
              { name: "PDF", id: 1 },
              { name: "Image", id: 2 },
            ]}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            value={formik?.values?.certificate_format}
            onBlur={formik.handleBlur("certificate_format")}
            onChange={(value) => {
              formik?.setFieldValue("certificate_format", value || null);
            }}
            menuPlacement="auto"
          />
          {getFieldError("certificate_format") && (
            <span className="error-text">
              {getFieldError("certificate_format")}
            </span>
          )}
        </div>
      )}

      <div>
        <div className="pro-font-sm pro-mb-1 pro-fw-medium">
          GLI Information
        </div>

        {getGliArrayError() && (
          <span className="error-text pro-mb-2 pro-d-block">
            {getGliArrayError()}
          </span>
        )}

        {gliEntries.map((entry, index) => {
          const asyncKey = `gli-${entry.id}-${selectedValId?.[0] || "default"}`;
          return (
            <div key={entry.id} className={Style.info_root}>
              {gliEntries.length > 1 && (
                <div className={Style.close_btn}>
                  <button onClick={() => handleRemoveGLI(entry.id)}>
                    <span
                      className="material-symbols-outlined x2"
                      title="Remove"
                    >
                      close
                    </span>
                  </button>
                </div>
              )}
              <div className="row gx-2 gy-3">
                <div className="col-12 col-md-4">
                  <div className="input-wrap mr-3">
                    <label
                      htmlFor={`gli-${entry.id}`}
                      className="pro-font-sm pro-mb-1 pro-fw-medium"
                    >
                      GLI
                    </label>
                    <AsyncPaginate
                      id={`gli-${entry.id}`}
                      key={asyncKey}
                      placeholder="Select"
                      className={`pro-input lg ${
                        getGliFieldError("gli_number", index) && "error"
                      }`}
                      classNamePrefix="pro-input"
                      isMulti={false}
                      name={`gli_data[${index}].gli_number`}
                      value={entry.gli_number}
                      loadOptions={loadGliOptions}
                      getOptionValue={(option) => option._id}
                      getOptionLabel={(option) => option.gli_number}
                      onChange={(value) =>
                        handleFieldChange("gli_number", value, entry.id, index)
                      }
                      menuPlacement="auto"
                      onBlur={() => {
                        formik.setFieldTouched(
                          `gli_data[${index}].gli_number`,
                          true
                        );
                        formik.setFieldTouched(`gli_data`, true);
                      }}
                      additional={{ page: 1 }}
                    />
                    {getGliFieldError("gli_number", index) && (
                      <span className="error-text">
                        {getGliFieldError("gli_number", index)}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="input-wrap mr-3">
                    <label
                      htmlFor={`status-${entry.id}`}
                      className="pro-font-sm pro-mb-1 pro-fw-medium"
                    >
                      Status
                    </label>
                    <Select
                      id={`status-${entry.id}`}
                      name={`gli_data[${index}].status`}
                      placeholder="Select"
                      className={`pro-input lg ${
                        getGliFieldError("status", index) && "error"
                      }`}
                      classNamePrefix="pro-input"
                      options={statusOptions}
                      getOptionLabel={(option) => option?.name}
                      getOptionValue={(option) => option?.id}
                      value={statusOptions.filter((option) =>
                        Array.isArray(entry.status)
                          ? entry.status.includes(option.id)
                          : false
                      )}
                      isMulti={true}
                      onChange={(selectedOptions) => {
                        const statusIds = selectedOptions.map(
                          (option) => option.id
                        );
                        handleFieldChange(
                          "status",
                          statusIds,
                          entry.id,
                          index
                        );
                      }}
                      onBlur={() => {
                        formik.setFieldTouched(
                          `gli_data[${index}].status`,
                          true
                        );
                        formik.setFieldTouched(`gli_data`, true);
                      }}
                      menuPlacement="auto"
                    />
                    {getGliFieldError("status", index) && (
                      <span className="error-text">
                        {getGliFieldError("status", index)}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="input-wrap mr-3">
                    <label
                      htmlFor={`report-${entry.id}`}
                      className="pro-font-sm pro-mb-1 pro-fw-medium"
                    >
                      Report Type
                    </label>
                    <Select
                      id={`report-${entry.id}`}
                      name={`gli_data[${index}].report_id`}
                      placeholder="Select"
                      className={`pro-input lg ${
                        getGliFieldError("report_id", index) && "error"
                      }`}
                      classNamePrefix="pro-input"
                      options={reportListData}
                      getOptionLabel={(option) => option?.name}
                      getOptionValue={(option) => option?._id}
                      value={entry.report_id}
                      onChange={(value) =>
                        handleFieldChange("report_id", value, entry.id, index)
                      }
                      onBlur={() => {
                        formik.setFieldTouched(
                          `gli_data[${index}].report_id`,
                          true
                        );
                        formik.setFieldTouched(`gli_data`, true);
                      }}
                      menuPlacement="auto"
                    />
                    {getGliFieldError("report_id", index) && (
                      <span className="error-text">
                        {getGliFieldError("report_id", index)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {(() => {
          const selectedGliIds = gliEntries
            .map((e) => e.gli_number?._id)
            .filter(Boolean);
          const remainingOptions = gliItems.filter(
            (item) => !selectedGliIds.includes(item._id)
          );
          return remainingOptions.length > 0 ? (
            <Button
              className="pro-btn-link pro-font-xs"
              style={{ margin: "10px 0px" }}
              onClick={handleAddGLI}
            >
              + Add GLI
            </Button>
          ) : null;
        })()}
      </div>

      <div className="input-wrap">
        <Input
          label={"Remarks"}
          type="text"
          id="remarks"
          name="remarks"
          className={`pro-input lg ${getFieldError("remarks") && " error"}`}
          {...formik.getFieldProps("remarks")}
          error={getFieldError("remarks")}
          errorMessage={getFieldError("remarks")}
        />
      </div>

      <div className={`col-12 pro-d-flex pro-justify-end`}>
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCloseModal}
          type="button"
        >
          Cancel
        </Button>
        <Button
          className={`pro-btn-primary lg pro-ms-3 ${isLoading ? "loading" : ""}`}
          type="submit"
          onClick={formik.handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </div>
  );
};

export default GLIPrintRecheck;
